import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  configs: { data: null, loading: false },
  publishConfigs: { data: null, loading: false },
  pageConfigs: [],
  activeConfig: null,
  copiedConfig: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
